import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import SingleEntry from "./SingleEntry";
import MultipleEntries from "./MultipleEntries";

const DayContent = ({ classes, date, idx, today, events, ...rest }) => {
  const [displayDate, setDisplayDate] = React.useState("");

  const renderEvents = (events) => {
    if (events.length === 1) {
      return <SingleEntry classes={classes} events={events} {...rest} />;
    } else if (events.length > 1) {
      return (
        <MultipleEntries classes={classes} events={events} date={displayDate} {...rest} />
      );
    }
  };

  React.useEffect(() => {
    if (idx === 0 || date.date() === 1) {
      setDisplayDate(date.format("MMM D"));
    } else {
      setDisplayDate(date.format("D"));
    }
  }, [idx, date]);

  return (
    <Box
      className={classes.dayWrapper}
      style={{
        backgroundColor: today ? "rgba(38, 187, 237, 0.1)" : "#FFF",
      }}
    >
      <Typography className={classes.date}>{displayDate}</Typography>
      {renderEvents(events)}
    </Box>
  );
};

export default DayContent;
